import { HTTP_CP_Company } from '@api-new/companyservice';
import { HTTP_CP_AdvisorUser } from '@api-new/userservice';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdviserContactDetails } from '@shared/models/adviser-contact-details.model';
import { AdviserState } from '@shared/store/adviser/adviser.state';
import { selectCompany } from '@shared/store/company/company.selectors';

export const selectAdviserState = createFeatureSelector<AdviserState>('adviser');

export const selectAdviser = createSelector(selectAdviserState, (state: AdviserState): HTTP_CP_AdvisorUser => state.adviser || null);

export const selectAdviserContactDetails = createSelector(
  selectAdviser,
  selectCompany,
  (adviser: HTTP_CP_AdvisorUser, company: HTTP_CP_Company): AdviserContactDetails =>
    adviser && {
      name: `${adviser.firstName} ${adviser.lastName}`,
      phoneNumber: adviser?.phoneNumber ? adviser.phoneNumber : company?.phone ? company.phone : null,
      email: adviser?.email ? adviser.email : company?.email ? company.email : null,
      companyLogo: company?.logo,
    },
);
